export { default } from './FieldsetLegend';
export type { FieldsetLegendProps } from './FieldsetLegend';
